(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atb-lifestyle-band"] && !Shopify.designMode) return;
  try {
    
/* atb-lifestyle-band — interactions. Progressive enhancement: the markup is fully
   usable before/without JS. Adds blur-up, scroll-reveal + Ken Burns,
   overflow-gated carousel chrome (counter + progress + arrows), and a lightbox.
   Each instance wires itself once; all motion honors prefers-reduced-motion. */
(function () {
  var REDUCE = false;
  try { REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  function pad2(n) { n = String(n); return n.length >= 2 ? n : '0' + n; }

  function init(root) {
    if (!root || root.dataset.atbLsbWired === '1') return;
    root.dataset.atbLsbWired = '1';

    var track = root.querySelector('[data-atb-lsb-track]');
    var slides = track ? Array.prototype.slice.call(root.querySelectorAll('[data-atb-lsb-slide]')) : [];
    var isCarousel = slides.length > 1;

    /* ── blur-up: fade each image in once it has decoded/loaded ───────────── */
    root.querySelectorAll('.atb-lsb__img').forEach(function (img) {
      var done = function () { img.classList.add('is-loaded'); };
      if (img.complete && img.naturalWidth > 0) { done(); }
      else { img.addEventListener('load', done, { once: true }); img.addEventListener('error', done, { once: true }); }
    });

    /* ── scroll reveal + in-view (drives Ken Burns play) ──────────────────── */
    if ('IntersectionObserver' in window) {
      var revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { root.classList.add('is-revealed', 'is-inview'); }
          else { root.classList.remove('is-inview'); }
        });
      }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
      revealIO.observe(root);
    } else {
      root.classList.add('is-revealed', 'is-inview');
    }

    /* ── lightbox — full, uncropped photo, mobile-safe ────────────────────── */
    var dialog = root.querySelector('[data-atb-lsb-lightbox]');
    if (dialog && root.hasAttribute('data-lightbox') && typeof dialog.showModal === 'function') {
      var dImg = dialog.querySelector('[data-atb-lsb-lightbox-img]');
      var closeBtn = dialog.querySelector('[data-atb-lsb-lightbox-close]');
      var stage = dialog.querySelector('[data-atb-lsb-lightbox-stage]');
      var scrollY = 0;

      var openDialog = function (full) {
        if (!full || !dImg) return;
        dImg.setAttribute('src', full);
        scrollY = window.scrollY || window.pageYOffset || 0;
        document.body.style.top = '-' + scrollY + 'px';
        document.body.classList.add('atb-lsb-lock');
        try { dialog.showModal(); } catch (e) {}
      };
      var closeDialog = function () { try { dialog.close(); } catch (e) {} };

      root.querySelectorAll('[data-atb-lsb-media]').forEach(function (media) {
        /* Tap-vs-swipe guard: only open if the pointer barely moved (so a
           horizontal swipe to scroll the carousel never triggers the lightbox). */
        var sx = 0, sy = 0, moved = false;
        media.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; moved = false; }, { passive: true });
        media.addEventListener('pointermove', function (e) {
          if (Math.abs(e.clientX - sx) > 10 || Math.abs(e.clientY - sy) > 10) moved = true;
        }, { passive: true });
        media.addEventListener('click', function (e) {
          e.preventDefault();
          if (moved) return;
          var fig = media.closest('[data-atb-lsb-slide]');
          openDialog(fig && fig.getAttribute('data-full'));
        });
      });

      if (closeBtn) closeBtn.addEventListener('click', closeDialog);
      if (stage) stage.addEventListener('click', closeDialog);            /* tap image or backdrop area */
      dialog.addEventListener('cancel', function (e) { /* Esc → native close */ });
      dialog.addEventListener('close', function () {
        document.body.classList.remove('atb-lsb-lock');
        document.body.style.top = '';
        window.scrollTo(0, scrollY);
        if (dImg) dImg.setAttribute('src', '');
      });
    }

    /* ── carousel: counter, progress, arrows, overflow gating ─────────────── */
    if (!isCarousel || !track) return;

    var prev = root.querySelector('[data-atb-lsb-prev]');
    var next = root.querySelector('[data-atb-lsb-next]');
    var countEl = root.querySelector('[data-atb-lsb-count]');
    var progressEl = root.querySelector('[data-atb-lsb-progress]');
    var total = slides.length;
    var current = 0;

    function syncOverflow() {
      var overflowing = (track.scrollWidth - track.clientWidth) > 1;
      root.classList.toggle('is-overflowing', overflowing);
    }
    syncOverflow();
    if ('ResizeObserver' in window) { new ResizeObserver(syncOverflow).observe(track); }
    else { window.addEventListener('resize', syncOverflow); }
    root.querySelectorAll('.atb-lsb__img').forEach(function (img) { img.addEventListener('load', syncOverflow, { once: true }); });

    function setActive(i) {
      if (i < 0) i = 0; if (i > total - 1) i = total - 1;
      current = i;
      if (countEl) countEl.textContent = 'N° ' + pad2(i + 1) + ' / ' + pad2(total);
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= total - 1;
    }
    function updateProgress() {
      if (!progressEl) return;
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? (track.scrollLeft / max) : 0;
      progressEl.style.transform = 'scaleX(' + Math.max(0.05, Math.min(1, p)).toFixed(3) + ')';
    }
    function scrollToIndex(i) {
      if (i < 0) i = 0; if (i > total - 1) i = total - 1;
      var t = slides[i]; if (!t) return;
      var left = t.offsetLeft - track.offsetLeft;
      try { track.scrollTo({ left: left, behavior: REDUCE ? 'auto' : 'smooth' }); }
      catch (e) { track.scrollLeft = left; }
      setActive(i);
    }

    if ('IntersectionObserver' in window) {
      var ratios = new WeakMap();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { ratios.set(e.target, e.intersectionRatio); });
        var best = -1, bestR = 0;
        for (var s = 0; s < total; s++) { var r = ratios.get(slides[s]) || 0; if (r > bestR) { bestR = r; best = s; } }
        if (best > -1 && best !== current) setActive(best);
      }, { root: track, threshold: [0.25, 0.5, 0.75, 1] });
      slides.forEach(function (s) { io.observe(s); });
    }
    var pTick = false;
    track.addEventListener('scroll', function () {
      if (pTick) return; pTick = true;
      window.requestAnimationFrame(function () { pTick = false; updateProgress(); });
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { scrollToIndex(current - 1); });
    if (next) next.addEventListener('click', function () { scrollToIndex(current + 1); });

    setActive(0); updateProgress();
  }

  /* body scroll lock used by the lightbox (added once) */
  if (!document.getElementById('atb-lsb-lock-style')) {
    var st = document.createElement('style');
    st.id = 'atb-lsb-lock-style';
    st.textContent = 'body.atb-lsb-lock{position:fixed;left:0;right:0;width:100%;overflow:hidden;}';
    document.head.appendChild(st);
  }

  function boot() { document.querySelectorAll('[data-atb-lsb]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector ? e.target.querySelector('[data-atb-lsb]') : null;
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
